import "./02_HearingSolution.css"
import { useState } from "react";

import Img1 from "../../../assets/images/hearingTestPage/1.jpg"
import icon from "../../../assets/images/testicon.svg"
import NavigationBar from "../../../components/01_navigationBar/01_navigationBar";
import Footer from "../../../components/02_footer/02_footer";

import img1 from "../../../assets/final/Images/04_HeaingSolutionsPage/01_HeroSection_HeroImage.png"

import img2 from "../../../assets/final/Images/04_HeaingSolutionsPage/02_HearingSolutions_Card_01.png"
import img3 from "../../../assets/final/Images/04_HeaingSolutionsPage/03_HearingSolutions_Card_02.jpg"
import img4 from "../../../assets/final/Images/04_HeaingSolutionsPage/04_HearingSolutions_Card_03.png"
import img5 from "../../../assets/final/Images/04_HeaingSolutionsPage/05_HearingSolutions_Card_04.jpg"
import img6 from "../../../assets/final/Images/04_HeaingSolutionsPage/06_HearingSolutions_Card_05.jpg"
import img7 from "../../../assets/final/Images/04_HeaingSolutionsPage/07_HearingSolutions_Card_06.png"
import img8 from "../../../assets/final/Images/04_HeaingSolutionsPage/08_HearingSolutions_Card_07.jpg"
import img9 from "../../../assets/final/Images/04_HeaingSolutionsPage/09_HearingSolutions_Card_08.png"

import ico1 from "../../../assets/final/Icons/03_HeaingSolutionsPage/01_ServiceCard_01_01.svg"
import ico2 from "../../../assets/final/Icons/03_HeaingSolutionsPage/02_ServiceCard_01_02.svg"
import ico3 from "../../../assets/final/Icons/03_HeaingSolutionsPage/03_ServiceCard_01_03.svg"

import ico4 from "../../../assets/final/Icons/03_HeaingSolutionsPage/04_ServiceCard_02_01.svg"
import ico5 from "../../../assets/final/Icons/03_HeaingSolutionsPage/05_ServiceCard_02_02.svg"
import ico6 from "../../../assets/final/Icons/03_HeaingSolutionsPage/06_ServiceCard_02_03.svg"

import ico7 from "../../../assets/final/Icons/03_HeaingSolutionsPage/07_ServiceCard_03_01.svg"
import ico8 from "../../../assets/final/Icons/03_HeaingSolutionsPage/08_ServiceCard_03_02.svg"
import ico9 from "../../../assets/final/Icons/03_HeaingSolutionsPage/09_ServiceCard_03_03.svg"

import ico10 from "../../../assets/final/Icons/03_HeaingSolutionsPage/10_ServiceCard_04_01.svg"
import ico11 from "../../../assets/final/Icons/03_HeaingSolutionsPage/11_ServiceCard_04_02.svg"
import ico12 from "../../../assets/final/Icons/03_HeaingSolutionsPage/12_ServiceCard_04_03.svg"

import ico13 from "../../../assets/final/Icons/03_HeaingSolutionsPage/13_ServiceCard_05_01.svg"
import ico14 from "../../../assets/final/Icons/03_HeaingSolutionsPage/14_ServiceCard_05_02.svg"
import ico15 from "../../../assets/final/Icons/03_HeaingSolutionsPage/15_ServiceCard_05_03.svg"

import ico16 from "../../../assets/final/Icons/03_HeaingSolutionsPage/16_ServiceCard_06_01.svg"
import ico17 from "../../../assets/final/Icons/03_HeaingSolutionsPage/17_ServiceCard_06_02.svg"
import ico18 from "../../../assets/final/Icons/03_HeaingSolutionsPage/18_ServiceCard_06_03.svg"

import ico19 from "../../../assets/final/Icons/03_HeaingSolutionsPage/19_ServiceCard_07_01.svg"
import ico20 from "../../../assets/final/Icons/03_HeaingSolutionsPage/20_ServiceCard_07_02.svg"
import ico21 from "../../../assets/final/Icons/03_HeaingSolutionsPage/21_ServiceCard_07_03.svg"

import ico22 from "../../../assets/final/Icons/03_HeaingSolutionsPage/22_ServiceCard_08_01.svg"
import ico23 from "../../../assets/final/Icons/03_HeaingSolutionsPage/23_ServiceCard_08_02.svg"
import ico24 from "../../../assets/final/Icons/03_HeaingSolutionsPage/24_ServiceCard_08_03.svg"

export default function HearingSolutions() {
    const [navHovered, setNavHovered] = useState(false); 
    const sections = [ 

    ]; 
    
    const scrollToSection = (id) => { 
        document.getElementById(id)?.scrollIntoView({ 
            behavior: "smooth", 
            block: "start", 
        }); 
    };
    
    return (
        <div>
            <NavigationBar />
            <div className={`HearingSolutionsPages-NavigationBar-Hider ${ navHovered ? "active" : "" }`}></div>
            <div className={`HearingSolutionsPages-NavigationBar-Hider-Slider ${ navHovered ? "active" : "" }`}></div>
            <div className="HearingSolutionsPages-HeroSection">
                <div className="HearingSolutionsPages-HeroSection-Info">
                    <h1 className="Title">
                        Personalized Hearing Solutions for Every Stage of Your Hearing Journey
                    </h1>
                    <p>
                        At Easy Hear, we believe that better hearing starts with the right guidance and continues with the right solution. Whether you're noticing the first signs of hearing loss, looking for advanced hearing aids, or need ongoing hearing care, our experienced audiologists are here to support you every step of the way.
                        <br /><br />
                        Our hearing solutions are tailored to your hearing needs, lifestyle, and long-term comfort—helping you stay connected to the conversations and moments that matter most.
                    </p>
                </div>
                <img src={img1} alt="" />
            </div>
            {/*
            <nav 
                className={`HearingSolutionsPages-NavigationBar ${ navHovered ? "expanded" : "" }`} 
                onMouseEnter={() => setNavHovered(true)} 
                onMouseLeave={() => setNavHovered(false)} > 
                {sections.map((section, index) => ( 
                    <button key={section.id} className="HearingSolutionsPages-NavigationBar-Item" onClick={() => scrollToSection(section.id)} > 
                        <span className="HearingSolutionsPages-NavigationBar-Clicker"> {index + 1} </span> 
                        <span className="HearingSolutionsPages-NavigationBar-Label"> {section.name} </span> 
                    </button> 
                ))} 
            </nav>
            */}
            <div id="assessment" className="HearingSolutionsPages-ServicesSection-Card">
                <div className="HearingSolutionsPages-ServicesSection-Card-Title">
                    <h2>Comprehensive Hearing Assessment</h2>
                    <img src={img2} alt="" />
                </div>
                <div className="HearingSolutionsPages-ServicesSection-Card-Info">
                    <h3>Every successful hearing solution begins with an accurate diagnosis.</h3>
                    <p>
                        Using advanced Pure Tone Audiometry (PTA) and other diagnostic evaluations, our audiologists assess your hearing ability to identify the type and degree of hearing loss. These detailed assessments help us recommend the most effective solution for your individual needs.
                    </p>
                    <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers">
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico1} alt="" />
                            <p>Accurate hearing assessment</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico2} alt="" />
                            <p>Sound-treated testing room</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico3} alt="" />
                            <p>Expert audiologist evaluation</p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="hearing-aids" className="HearingSolutionsPages-ServicesSection-Card">
                <div className="HearingSolutionsPages-ServicesSection-Card-Title">
                    <h2>Expert Hearing Consultation</h2>
                    <img src={img3} alt="" />
                </div>
                <div className="HearingSolutionsPages-ServicesSection-Card-Info">
                    <h3>Understanding your hearing is the first step toward improving it.</h3>
                    <p>
                        Our hearing consultations provide you with expert guidance, allowing you to discuss your hearing concerns, understand your test results, and explore the treatment options best suited to your lifestyle and communication needs.
                    </p>
                    <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers">
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico4} alt="" />
                            <p>One-on-one consultation</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico5} alt="" />
                            <p>Personalized guidance</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico6} alt="" />
                            <p>Tailored hearing solutions</p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="hearing-care" className="HearingSolutionsPages-ServicesSection-Card">
                <div className="HearingSolutionsPages-ServicesSection-Card-Title">
                    <h2>Personalized Hearing Aid Solutions</h2>
                    <img src={img4} alt="" />
                </div>
                <div className="HearingSolutionsPages-ServicesSection-Card-Info">
                    <h3>
                        No two people hear the same way, which is why no single hearing aid works for everyone.
                    </h3>
                    <p>
                        We help you choose from a wide range of hearing aids from trusted brands, carefully selecting the device that offers the right balance of comfort, performance, technology, and budget. Our goal is to help you hear naturally and confidently in every situation.
                    </p>
                    <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers">
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico7} alt="" />
                            <p>Personalized recommendations</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico8} alt="" />
                            <p>Trusted hearing aid brands</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico9} alt="" />
                            <p>Rechargeable & battery options</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="HearingSolutionsPages-ServicesSection-Card">
                <div className="HearingSolutionsPages-ServicesSection-Card-Title">
                    <h2>Hearing Aid Care & Maintenance</h2>
                    <img src={img5} alt="" />
                </div>
                <div className="HearingSolutionsPages-ServicesSection-Card-Info">
                    <h3>
                        Keeping your hearing aids in excellent condition is essential for consistent performance.
                    </h3>
                    <p>
                        From routine servicing and professional cleaning to repairs and programming adjustments, we ensure your hearing aids continue delivering the best possible hearing experience for years to come.
                    </p>
                    <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers">
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico10} alt="" />
                            <p>Professional repairs</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico11} alt="" />
                            <p>Cleaning & maintenance</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico12} alt="" />
                            <p>Performance optimization</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="HearingSolutionsPages-ServicesSection-Card">
                <div className="HearingSolutionsPages-ServicesSection-Card-Title">
                    <h2>Hearing Aid Batteries & Accessories</h2>
                    <img src={img6} alt="" />
                </div>
                <div className="HearingSolutionsPages-ServicesSection-Card-Info">
                    <h3>The right accessories help you get the most from your hearing aids.</h3>
                    <p>
                        We offer genuine batteries, chargers, cleaning kits, ear domes, wax guards, and other essential accessories to ensure your hearing devices remain reliable, comfortable, and easy to use every day.
                    </p>
                    <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers">
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico13} alt="" />
                            <p>Genuine batteries</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico14} alt="" />
                            <p>Cleaning accessories</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico15} alt="" />
                            <p>Chargers & maintenance kits</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="HearingSolutionsPages-ServicesSection-Card">
                <div className="HearingSolutionsPages-ServicesSection-Card-Title">
                    <h2>Preventive Hearing Care</h2>
                    <img src={img7} alt="" />
                </div>
                <div className="HearingSolutionsPages-ServicesSection-Card-Info">
                    <h3>Your hearing deserves regular attention—even before problems become noticeable.</h3>
                    <p>
                        Routine hearing check-ups help detect early changes in hearing health, allowing timely intervention and better long-term outcomes. Preventive care is especially valuable for older adults, individuals exposed to loud noise, and anyone looking to protect their hearing.
                    </p>
                    <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers">
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico16} alt="" />
                            <p>Early detection</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico17} alt="" />
                            <p>Preventive hearing care</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico18} alt="" />
                            <p>Expert consultation</p>
                        </div>
                    </div>
                </div>
            </div>
            <div  className="HearingSolutionsPages-ServicesSection-Card">
                <div className="HearingSolutionsPages-ServicesSection-Card-Title">
                    <h2>Speech Understanding Assessment</h2>
                    <img src={img8} alt="" />
                </div>
                <div className="HearingSolutionsPages-ServicesSection-Card-Info">
                    <h3>Hearing sounds is one thing—understanding conversations is another.</h3>
                    <p>
                        Our speech testing evaluates how clearly you recognize and understand spoken words in different listening environments. These insights help us recommend hearing solutions that improve real-life communication, not just hearing test results.
                    </p>
                    <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers">
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico19} alt="" />
                            <p>Speech clarity assessment</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico20} alt="" />
                            <p>Better hearing analysis</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico21} alt="" />
                            <p>Personalized recommendations</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="HearingSolutionsPages-ServicesSection-Card">
                <div className="HearingSolutionsPages-ServicesSection-Card-Title">
                    <h2>Tinnitus Management</h2>
                    <img src={img9} alt="" />
                </div>
                <div className="HearingSolutionsPages-ServicesSection-Card-Info">
                    <h3>Living with ringing or buzzing in the ears can be frustrating, but support is available.</h3>
                    <p>
                        Our tinnitus management solutions include comprehensive evaluations, expert counseling, and personalized recommendations designed to reduce the impact of tinnitus and help you regain comfort and confidence in your daily life.
                    </p>
                    <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers">
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico22} alt="" />
                            <p>Tinnitus evaluation</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico23} alt="" />
                            <p>Personalized management</p>
                        </div>
                        <div className="HearingSolutionsPages-ServicesSection-Card-Info-Pointers-Keys">
                            <img src={ico24} alt="" />
                            <p>Ongoing support</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}